/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import GroupsIcon from '@mui/icons-material/Groups';
import Constants from '../../constants';
import gaEventConstants from '../../constants/gaEventConstants';
import { gaTriggerGTMCustomEvents } from '../../../ga';

const BulkActionButton = () => {
  const invokeGAEvent = () => {
    const BulkActionClickGTMData = {
      event: gaEventConstants.BULK_ACTION_CLICKED
    };
    gaTriggerGTMCustomEvents(BulkActionClickGTMData);
  };

  const handleClick = () => {
    invokeGAEvent();
    window.open('/#/bulkactions', '_blank');
  };
  return (
    <button
      className="user-detail__user-manager"
      type="button"
      title={Constants.BULK_ACTIONS}
      data-testid="bulk-action-btn"
      onClick={handleClick}
    >
      <GroupsIcon />
      {Constants.BULK_ACTIONS}
    </button>
  );
};
export default BulkActionButton;
